// Softinya'nın kendi GA4 Measurement ID'leri
const MAIN_GA_IDS = ['G-QNNFJ1HF3Z', 'G-8HYZNQFD9T'];

// Şirkete özel GA4 Measurement ID'leri (alias → GA ID)
const COMPANY_GA_IDS = {
  azcon: 'G-Z2FX2NNECR',
};

export default class GoogleAnalyticsService {
  static _companyGaId = null;

  static init() {
    const primaryId = MAIN_GA_IDS[0];

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${primaryId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());

    // Her iki Softinya GA property'sini de başlat
    MAIN_GA_IDS.forEach(id => gtag('config', id));

    window.gtag = gtag;
  }

  /**
   * Şirkete özel GA4 property'sini başlatır.
   * Aynı gtag instance'ı üzerinden ek bir config ekler,
   * böylece şirket kendi GA panelinde sadece kendi verilerini görür.
   */
  static initCompanyGA(alias) {
    const companyGaId = COMPANY_GA_IDS[alias];
    if (!companyGaId || !window.gtag) return;

    this._companyGaId = companyGaId;
    window.gtag('config', companyGaId);
  }

  static trackPageView(page) {
    if (!window.gtag) return;

    MAIN_GA_IDS.forEach(id => {
      window.gtag('config', id, { page_path: page });
    });

    if (this._companyGaId) {
      window.gtag('config', this._companyGaId, { page_path: page });
    }
  }
}
